<template>
  <div>
    <b-card header-class="border-0" v-show="showFilter">
      <b-row>
        <b-col>
          <base-input label="Patient">
            <customerSelect v-on:nameSelected="nameSelected"></customerSelect>
            <small>Search by first name or e-mail</small>
          </base-input>
        </b-col>
        <b-col>
          <label class="form-control-label">Start Date</label>
          <b-form-datepicker
            id="startDate"
            v-model="form.startDate"
            class="col-sm-12"
            locale="en"
          ></b-form-datepicker>
        </b-col>
        <b-col>
          <label class="form-control-label">End Date</label>
          <b-form-datepicker
            id="endDate"
            v-model="form.endDate"
            class="col-sm-12"
            locale="en"
          ></b-form-datepicker>
        </b-col>
        <b-col>
          <label class="form-control-label">Status</label>
          <b-form-checkbox-group
            :options="statuses"
            v-model="form.statuses"
            stacked
          />
        </b-col>
        <b-col>
          <label class="form-control-label">Modules</label>
          <b-form-checkbox-group
            :options="modules"
            v-model="form.modules"
            stacked
          />
        </b-col>
      </b-row>
    </b-card>

    <b-card body-class="p-0" header-class="border-0">
      <transaction-search-results :query="form" @hideFilter="hideFilter" />
    </b-card>
  </div>
</template>
<script>
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import TransactionSearchResults from "@/views/Components/Transactions/SearchResults";

import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
} from "element-ui";

export default {
  name: "light-table",
  title: "Transactions",
  inject: ["hasRole"],
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    flatPicker,
    TransactionSearchResults,
  },
  props: {
    itemLimit: {
      type: Number,
      default: 9,
    },
  },
  created() {
    if (this.$route.query.startDate) {
      this.form.startDate = new Date(this.$route.query.startDate);
    }

    if (this.$route.query.endDate) {
      alert(this.$route.query.endDate);
      this.form.endDate = new Date(this.$route.query.endDate);
    }

    if (this.$route.query.showApproved) {
      this.form.statuses = ["APPROVED"];
    }

    if (this.$route.query.showDeclined) {
      this.form.statuses = ["DECLINED"];
    }

    if (this.$route.query.module == "OTHER") {
      this.form.modules = ["TERMINAL", "VIRTUALTERMINAL"];
    } else if (this.$route.query.module) {
      this.form.modules = [this.$route.query.module];
    }
  },
  data() {
    return {
      showFilter: true,
      statuses: [
        { value: "APPROVED", text: "Approved" },
        { value: "DECLINED", text: "Declined" },
      ],
      modules: null,

      form: {
        startDate: null,
        endDate: null,
        customerId: null,
        modules: [
          "TERMINAL",
          "PAYMENTPLAN",
          "TEXTTOPAY",
          "VIRTUALTERMINAL",
          "MEMBERSHIP",
          "PAYMENTPAGE",
        ],
        statuses: ["APPROVED", "DECLINED"],
      },
      paymentPlans: [],
      currentPage: 1,
    };
  },
  created() {
    this.modules = [];
    if (this.hasRole("VIEWPAYMENTPLANS"))
      this.modules.push({ value: "PAYMENTPLAN", text: "Payment Plan" });

    if (this.hasRole("VIEWMEMBERSHIPS"))
      this.modules.push({ value: "MEMBERSHIP", text: "Membership" });

    if (this.hasRole("VIEWPAYMENTREQUESTS"))
      this.modules.push({ value: "TEXTTOPAY", text: "Payment Request" });

    this.modules.push({ value: "PAYMENTPAGE", text: "Payment Page" });
  },
  methods: {
    hideFilter() {
      var self = this;
      this.showFilter = false;
    },
    nameSelected(customer) {
      this.form.customerId = customer.id;
    },
    query() {},
  },
};
</script>
